import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )

  return Yup.object({
    subscriptionCode: Yup.string().required(requiredMessage),
    subscriptionName: Yup.string().required(requiredMessage),
    subscriptionDescription: Yup.string().required(requiredMessage),
    status: Yup.string(),
  })
}

export default makeValidationSchema
